import { Route } from "react-router-dom";
import SignupChooseView from "src/views/auth/signup/SignupChooseView";
import ForgotPasswordResetView from "src/views/auth/forgot-password/ForgotPasswordResetView";
import ForgotPasswordView from "src/views/auth/forgot-password/ForgotPasswordView";
import LoginView from "src/views/auth/LoginView";
import SignupStudentView from "src/views/auth/signup/SignupStudentView";
import SignupCompanyView from "src/views/auth/signup/company/SignupCompanyView";
import SignupCompanySearchView from "src/views/auth/signup/company/SignupCompanySearchView";
import SignupCompanyInformationView from "src/views/auth/signup/company/SignupCompanyInformationView";
import SignupCompanyUserView from "src/views/auth/signup/company/SignupCompanyUserView";
import SingupCompanyInviteView from "src/views/auth/signup/company/invite/SingupCompanyInviteView";

const AuthRoutes = [
	<Route element={<LoginView />} path="/login" key="/login" />,
	<Route
		element={<ForgotPasswordView />}
		path="/forgot-password"
		key="/forgot-password"
	/>,
	<Route
		element={<ForgotPasswordResetView />}
		path="/forgot-password/:token"
		key="/forgot-password/:token"
	/>,
	<Route element={<SignupChooseView />} path="/signup" key="/signup" />,
	<Route
		element={<SignupStudentView />}
		path="/signup/student"
		key="/signup/student"
	/>,
	<Route
		element={<SignupCompanyView />}
		path="/signup/company"
		key="/signup/company"
	/>,
	<Route
		element={<SignupCompanySearchView />}
		path="/signup/company/:slug"
		key="/signup/company/:slug"
	/>,

	<Route
		element={<SignupCompanyInformationView />}
		path="/signup/company/:slug/information"
		key="/signup/company/:slug/information"
	/>,
	<Route
		element={<SignupCompanyUserView />}
		path="/signup/company/:slug/information/contact"
		key="/signup/company/:slug/information/contact"
	/>,
	<Route
		element={<SingupCompanyInviteView />}
		path="/signup/company/:hid/invite"
		key="/signup/company/:hid/invite"
	/>,
];

export default AuthRoutes;
